/** Window events and constants shared by the chat socket, the sidebar badge and the chat pages. */

/** Fired every time the notification socket (re)connects, so unread badges can re-sync. */
export const CHAT_SOCKET_CONNECTED_EVENT = "chat-socket-connected";

/** Fired after the support chat page marked the support room read on the server. */
export const ADMIN_CHAT_READ_EVENT = "admin-chat-read";

/**
 * `room_context` of the provider's support room with the admin team. Rooms between the provider
 * and a patient carry no context (null), so this is what tells admin messages apart.
 */
export const ADMIN_PROVIDER_CONTEXT = "admin_provider";

export const isAdminSupportMessage = (data) =>
  data?.room_context === ADMIN_PROVIDER_CONTEXT;
